module.exports = __webpack_public_path__ + "static/media/nikola_muckova.4e10b1f9.jpg";